﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { ServiciosHelpText, ServiciosIcon } from "../../Servicios/Servicios";
import { ClientesTiendasServiciosDef } from "./ClientesTiendasServiciosDef";

export class ClientesTiendasServicios extends Entity<ClientesTiendasServiciosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ClientesTiendasServiciosDef(), parentKeys);
        super.Form = import('./ClientesTiendasServiciosForm').then((module) => module.ClientesTiendasServiciosForm);
        this.Title = "Servicios"
        this.Icon = ServiciosIcon;
        this.HelpText = ServiciosHelpText;
    }
}